export default "<img class=\"center\" src=\"assets/under_construction.png\">"